import { createContext, useContext, useState, useCallback, useMemo } from "react";

const RegisterModalContext = createContext(null);

export const RegisterModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);
  const value = useMemo(() => ({ isOpen, openModal, closeModal }), [isOpen, openModal, closeModal]);

  return (
    <RegisterModalContext.Provider value={value}>
      {children}
    </RegisterModalContext.Provider>
  );
};

export const useRegisterModal = () => {
  const ctx = useContext(RegisterModalContext);
  if (!ctx) throw new Error("useRegisterModal must be used within RegisterModalProvider");
  return ctx;
};
